import { userConstants } from "../../constant";
const initialState = {
  sellerOrderItem: [],
};
export function orders(state = { initialState }, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_ORDERS:
      return {
        sellerOrderItem: action.payload,
      };
    case userConstants.FILTER_SELLER_ORDERS:
      return {
        sellerOrderItem: [...state, action.payload],
      };

    default:
      return state;
  }
}
